import React from "react";

const ProfileIcon = ({ imgUrl, style, isSmall }) => {
  return (
    <img
      style={{
        width: isSmall ? 100 : 150,
        height: isSmall ? 100 : 150,
        borderRadius: "50%",
        objectFit: "cover",
        ...style,
      }}
      src={imgUrl ? imgUrl : "/assets/icons/profile.png"}
      alt="프로필 이미지"
    />
  );
};

export default ProfileIcon;
